<template>
  <v-container fluid pa-0>
    <div class="d-flex flex-row justify-end align-center pb-2">
      <v-checkbox v-model="group" hide-details class="my-0 mx-1"></v-checkbox>
      <div>
        <v-select
          :disabled="!group"
          :items="groupOptions"
          v-model="selectedGroupOption"
          label="Group by"
          item-text="label"
          item-value="method"
          :outlined="outlinedInputs"
          hide-details
          class="mr-2"
        ></v-select>
      </div>
      <list-visible-columns-and-filter
        :visible-columns="visibleColumns"
        :selectable-headers="selectableHeaders"
        v-model="search"
        @change="onVisibleColumnsChange"
      ></list-visible-columns-and-filter>
      <v-btn
        class="ml-2"
        @click="onShowAddRatesSeason"
        color="primary"
        :disabled="$store.getters.hasAccessTo('suppliers:view_only')"
      >
        <v-icon left>mdi-calendar-import</v-icon>Add Rates
      </v-btn>
      <add-rates-season
        :show="showAddRatesSeason"
        :services="services"
        :supplier="supplier"
        @close="showAddRatesSeason = false"
      ></add-rates-season>
    </div>

    <v-layout>
      <v-flex>
        <v-layout>
          <v-flex>
            <v-card my-1>
              <v-layout row pa-3>
                <v-flex sm4>
                  <dates-range-picker
                    :gt-date-from-string="dateFrom"
                    :gt-date-to-string="dateTo"
                    :date-from-range-start="dateFromRangeStart"
                    :date-to-range-end="dateToRangeEnd"
                    :outlined="outlinedInputs"
                    @input="onDatesRangeSelected"
                  ></dates-range-picker>
                </v-flex>
                <v-flex sm3>
                  <v-autocomplete
                    :items="agentGroups"
                    v-model="selectedAgentGroup"
                    label="Agent Group"
                    item-text="name"
                    item-value="id"
                    :outlined="outlinedInputs"
                  ></v-autocomplete>
                </v-flex>
                <v-flex sm3>
                  <gt-multi-select
                    :items="selectableServices"
                    v-model="selectedServices"
                    item-text="node.name"
                    item-value="node.id"
                    label="Service"
                    :outlined="outlinedInputs"
                  ></gt-multi-select>
                </v-flex>
                <v-flex>
                  <v-switch
                    v-model="serviceNotInUseFilter"
                    label="Not In Use"
                    dense
                  ></v-switch>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
        <supplier-rates-edit-list-table-view
          v-if="!group"
          :supplier-rates-list="supplierRatesList"
          :rate-types="rateTypes"
          :agent-groups="agentGroups"
          @editItem="onEditItem($event)"
          @deleteItem="onDeleteItem($event)"
          @deleteRecords="onDeleteRecords"
          :headers="headers"
          :visibleColumns="visibleColumns"
          :search="search"
          :services="services"
          class="mt-2"
          @export="onExport"
          @export-all="onExportAll"
        ></supplier-rates-edit-list-table-view>
        <v-layout v-else>
          <v-flex xs12>
            <div v-for="key in Object.keys(groupedRatesList)" :key="key">
              <h5 class="title text-xs-left pb-3 pt-3">
                {{ groupedRatesList[key].label }}
              </h5>
              <supplier-rates-edit-list-table-view
                :supplier-rates-list="groupedRatesList[key].items"
                :rate-types="rateTypes"
                :agent-groups="agentGroups"
                @editItem="onEditItem($event)"
                @deleteItem="onDeleteItem($event)"
                @deleteRecords="onDeleteRecords"
                :headers="headers"
                :visibleColumns="visibleColumns"
                :search="search"
                @export="onExport"
                @export-all="onExportAll"
              ></supplier-rates-edit-list-table-view>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-card>
      <v-dialog v-model="supplierRatePriceEditorDialog" scrollable persistent>
        <price-details-editor
          :price-id="selectedPriceId"
          :rate-types="rateTypes"
          :agent-groups="agentGroups"
          @onSave="onSave"
          @onCloseDialog="supplierRatePriceEditorDialog = false"
          :services="services"
          :hide-children="supplier && supplier.extrasChildPrice"
        ></price-details-editor>
      </v-dialog>
    </v-card>
    <list-export
      :show="showExportSettings"
      @close="showExportSettings = false"
      @export="onStartExport"
      :records="selectedRows"
      :columns="visibleColumns"
      list="Prices"
      :filter="searchParams"
      @complete="onExportComplete"
    />

    <v-row v-if="debug">
      <code>{{ searchParams }}</code>
    </v-row>
  </v-container>
</template>

<script>
import {
  SUPPLIER_RATES_QUERY,
  SERVICE_PRICE_DELETE_MUTATION,
  REMOVE_RECORDS,
} from "../../../../../constants/graphql";
import SupplierRatesEditListVlistView from "./SupplierRatesEditListVlistView";
import SupplierRatesEditListTableView from "./SupplierRatesEditListTableView";
import SupplierRatesAdd from "../add/SupplierRatesAdd";
import EventBus from "../../../../../store/event-bus";
import PriceDetailsEditor from "./price-details/PriceDetailsEditor";
import ListVisibleColumnsAndFilter from "../../../shared/ListVisibleColumnsAndFilter";
import { sortByDate } from "../../../../../helpers/index";
import DatesRangePicker from "../../../shared/DatesRangePicker";
import GtMultiSelect from "../../../shared/GtMultiSelect";
import AddRatesSeason from "../add/AddRatesSeason";
import ListExport from "../../../shared/list-actions/ListExport.vue";
const moment = require("moment");
export default {
  name: "SupplierRatesEditList",
  components: {
    SupplierRatesEditListTableView,
    SupplierRatesEditListVlistView,
    SupplierRatesAdd,
    PriceDetailsEditor,
    ListVisibleColumnsAndFilter,
    DatesRangePicker,
    GtMultiSelect,
    AddRatesSeason,
    ListExport,
  },
  props: {
    supplierId: {
      type: String,
      default: "",
    },
    supplier: {
      type: Object,
      default: () => {},
    },
    services: {
      type: Array,
      default: () => [],
    },
    rateTypes: {
      type: Array,
      default: () => [],
    },
    agentGroups: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      debug: false,
      group: false,
      groupOptions: [
        { label: "Date Band", method: "bySeason" },
        { label: "Services", method: "byService" },
        { label: "Remarks", method: "byRemarks" },
      ],
      dateFrom: moment().toISOString(true),
      dateTo: null,
      selectedServices: [],
      selectedAgentGroup: "",
      serviceNotInUseFilter: false,
      selectedGroupOption: "bySeason",
      supplierRatesList: [],
      showList: false,
      showAddRates: false,
      showAddRatesSeason: false,
      ratesAddRenderKey: 1,
      supplierRatePriceEditorDialog: false,
      selectedPriceId: "",
      search: "",
      visibleColumns: this.$store.getters.localSettings(this.$options.name, [
        "dateFrom",
        "dateTo",
        "service",
        "rateTypeCode",
        "adultBuy1",
        "adultSell1",
        "actions",
      ]),
      showExportSettings: false,
      selectedRows: [],
    };
  },
  computed: {
    headers() {
      return [
        {
          text: "Date From",
          align: "left",
          name: "dateFrom",
          value: "dateFrom",
          sort: sortByDate,
        },
        {
          text: "Date To",
          align: "left",
          name: "dateTo",
          value: "dateTo",
          sort: sortByDate,
        },
        {
          text: "Service",
          align: "left",
          value: "service.name",
          name: "service",
        },
        {
          text: "Code",
          align: "left",
          value: "service.code",
          name: "code",
        },
        {
          text: "Rate Type",
          align: "left",
          value: "rateTypeCode",
          name: "rateTypeCode",
        },
        {
          text: "Agent Group",
          align: "left",
          value: "agentGroup",
          name: "agentGroup",
        },
        {
          text: "Rate Plan",
          align: "left",
          value: "ratePlan",
          name: "ratePlan",
        },
        {
          text: "Business Model",
          align: "left",
          value: "businessModel",
          name: "businessModel",
        },
        {
          text: "Supplier Commission",
          align: "left",
          value: "supplierCommission",
          name: "supplierCommission",
        },
        {
          text: "Cost",
          align: "left",
          value: "adultBuy1",
          name: "adultBuy1",
        },
        {
          text: "Sell",
          align: "left",
          value: "adultSell1",
          name: "adultSell1",
        },
        {
          text: "Child Cost",
          align: "left",
          value: "childBuy1",
          name: "childBuy1",
        },
        {
          text: "Child Sell",
          align: "left",
          value: "childSell1",
          name: "childSell1",
        },
        {
          text: "Infant Cost",
          align: "left",
          value: "infantBuy1",
          name: "infantBuy1",
        },
        {
          text: "Infant Sell",
          align: "left",
          value: "infantSell1",
          name: "infantSell1",
        },
        {
          text: "Currency",
          align: "left",
          value: "currencyCode",
          name: "currencyCode",
        },
        {
          text: "Markup",
          align: "left",
          value: "markup",
          name: "markup",
        },
        {
          text: "Market Place",
          align: "left",
          value: "marketPlace",
          name: "marketPlace",
        },
        {
          text: "API",
          align: "left",
          value: "api",
          name: "api",
        },
        {
          text: "Min Stay",
          align: "left",
          value: "minStay",
          name: "minStay",
        },
        {
          text: "Max Stay",
          align: "left",
          value: "maxStay",
          name: "maxStay",
        },
        {
          text: "Min Pax",
          align: "left",
          value: "minPax",
          name: "minPax",
        },
        {
          text: "Max Pax",
          align: "left",
          value: "maxPax",
          name: "maxPax",
        },
        {
          text: "Exception",
          align: "center",
          value: "exception",
          name: "exception",
        },
        {
          text: "Remarks",
          align: "left",
          value: "remarks",
          name: "remarks",
        },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          name: "actions",
          align: "center",
        },
      ].filter((h) => {
        if (h.name == "marketPlace") {
          return this.$store.getters.hasAccessTo("third_party:marketplace");
        } else if (
          h.name == "businessModel" ||
          h.name == "supplierCommission"
        ) {
          return this.$store.getters.hasAccessTo(
            "administration_panel:business_models"
          );
        } else {
          return true;
        }
      });
    },
    selectableServices() {
      return this.services.filter(
        (s) => s.node.notInUse == this.serviceNotInUseFilter
      );
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    groupedRatesList() {
      return this[this.selectedGroupOption]();
    },
    selectableHeaders() {
      return this.headers.filter((h) => h.name !== "actions");
    },
    dateFromRangeStart() {
      return moment().subtract(10, "years").toISOString(true);
    },
    dateToRangeEnd() {
      return moment().add(10, "years").toISOString(true);
    },
    searchParams() {
      const filters = {
        dateTo_gte: this.dateFrom,
        dateFrom_lte: this.dateTo ? this.dateTo : undefined,
        services: this.selectedServices,
        notInUse: this.serviceNotInUseFilter,
        supplierId_eq: this.supplierId,
      };
      if (this.selectedAgentGroup != "") {
        filters.agentGroupId = this.selectedAgentGroup;
      }
      return filters;
    },
  },

  methods: {
    onExport(payload) {
      this.selectedRows = payload;
      this.showExportSettings = true;
    },
    onExportAll(payload) {
      this.selectedRows = [];
      this.showExportSettings = true;
    },
    onExportClose() {
      console.log("closing export");
    },
    onExportComplete() {
      console.log("export complete");
    },
    onStartExport() {
      console.log("export start");
    },

    refetchSupplierRates() {
      if (this.$apollo.queries.supplierRates != null) {
        this.$apollo.queries.supplierRates.refetch();
      }
    },
    onSave() {
      this.$store.dispatch("showAppSnackbar", { msg: "Supplier Rate saved." });
      this.selectedPriceId = "";
      this.supplierRatePriceEditorDialog = false;

      EventBus.$emit("refetch-supplier-rates");
    },
    onEditItem(item) {
      this.selectedPriceId = item.id;
      this.supplierRatePriceEditorDialog = true;
    },
    async onDeleteRecords(payload) {
      try {
        const resp = await this.$apollo.mutate({
          mutation: REMOVE_RECORDS,
          variables: { input: payload.map((item) => item.id) },
        });
        this.$store.dispatch("showAppSnackbar", {
          msg: "Rates removed",
        });
        EventBus.$emit("refetch-supplier-rates");
      } catch (error) {
        this.removeGqlObjectErrorHandler(error);
      }
    },
    onDeleteItem(item) {
      this.$apollo
        .mutate({
          mutation: SERVICE_PRICE_DELETE_MUTATION,
          variables: {
            priceId: item.id,
          },
        })
        .then(this.removeGqlObjectHandler, this.removeGqlObjectErrorHandler);
    },
    removeGqlObjectHandler(result) {
      this.$store.dispatch("showAppSnackbar", {
        msg: "Supplier Rate Removed.",
      });
      EventBus.$emit("refetch-supplier-rates");
    },
    removeGqlObjectErrorHandler(err) {
      const errorMsg = err.graphQLErrors.map((e) => e.message).join(", ");
      this.$store.dispatch("showAppSnackbar", {
        msg: errorMsg,
        color: "error",
      });
    },
    onShowRatesAdd() {
      this.showAddRates = true;
    },
    onShowAddRatesSeason() {
      this.showAddRatesSeason = true;
    },
    onCloseRatesAdd() {
      this.showAddRates = false;
      //refresh
      this.ratesAddRenderKey++;
    },
    onRatesSaved() {
      this.showAddRates = false;
      //refresh
      this.ratesAddRenderKey++;
    },
    bySeason() {
      return this.supplierRatesList.reduce((group, item) => {
        group[item.dateFrom + item.dateTo] = group[
          item.dateFrom + item.dateTo
        ] || { label: "", items: [] };
        group[item.dateFrom + item.dateTo].label =
          "Season: (From: " +
          this.$options.filters.formatDate(item.dateFrom) +
          ", To: " +
          this.$options.filters.formatDate(item.dateTo) +
          ")";
        group[item.dateFrom + item.dateTo].items.push(item);
        return group;
      }, {});
    },
    byService() {
      return this.supplierRatesList.reduce((group, item) => {
        group[item.service.id] = group[item.service.id] || {
          label: "",
          items: [],
        };
        group[item.service.id].label = item.service.name;
        group[item.service.id].items.push(item);
        return group;
      }, {});
    },
    byRemarks() {
      return this.supplierRatesList.reduce((group, item) => {
        group[item.remarks] = group[item.remarks] || {
          label: "",
          items: [],
        };
        group[item.remarks].label = item.remarks;
        group[item.remarks].items.push(item);
        return group;
      }, {});
    },
    onVisibleColumnsChange(event) {
      this.visibleColumns = [...event];
      this.$store.dispatch("updateLocalSettings", {
        [this.$options.name]: event,
      });
    },
    onDatesRangeSelected(data) {
      this.dateTo = data.dateTo;
      this.dateFrom = data.dateFrom;
    },
  },
  apollo: {
    supplierRates: {
      query: SUPPLIER_RATES_QUERY,
      variables() {
        return {
          supplierId: this.supplierId,
          filter: this.searchParams,
        };
      },
      skip() {
        return !this.supplierId;
      },
      fetchPolicy: "network-only",
      result({ data }) {
        this.supplierRatesList = data.supplierRates.edges.map(
          (item) => item.node
        );
      },
    },
  },

  mounted() {
    EventBus.$on("refetch-supplier-rates", () => {
      this.refetchSupplierRates();
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/gt/suppliers/supplier-rates/edit/SupplierRatesEditList.vue